/**
 * src/services/solicitudes.js
 *
 * Gestión de solicitudes públicas.
 * - saveSolicitud(): POST al Cloudflare Worker (sin token en el navegador)
 * - getSolicitudes(): lee /data/solicitudes.json (estático)
 * - removeSolicitud(): solo admin, usa token de localStorage
 */

const WORKER_URL = 'https://ubiyaaa-solicitudes.mario-acalderon16.workers.dev'

const OWNER  = 'marioacalderon16-dev'
const REPO   = 'directorio'
const BRANCH = 'main'
const PATH   = 'public/data/solicitudes.json'

export async function getSolicitudes() {
    try {
        const res = await fetch(`/data/solicitudes.json?t=${Date.now()}`)
        if (!res.ok) return []
        const data = await res.json()
        return Array.isArray(data) ? data : []
    } catch {
        return []
    }
}

export async function saveSolicitud(solicitud) {
    const res = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(solicitud),
    })
    if (!res.ok) {
        const err = await res.json().catch(() => ({}))
        throw new Error(err.error || `Error ${res.status}`)
    }
    return res.json()
}

export async function removeSolicitud(solId) {
    const token = localStorage.getItem('adm-github')
    if (!token) throw new Error('Sin token de GitHub')

    const getRes = await fetch(`https://api.github.com/repos/${OWNER}/${REPO}/contents/${PATH}?ref=${BRANCH}`, {
        headers: { Authorization: `Bearer ${token}`, Accept: 'application/vnd.github+json' },
    })
    if (!getRes.ok) throw new Error('No se pudo leer solicitudes')

    const json = await getRes.json()
    const content = decodeURIComponent(escape(atob(json.content.replace(/\n/g, ''))))
    const current = JSON.parse(content)
    const updated = current.filter(s => s._solId !== solId)

    const body = {
        message: `solicitud: eliminar ${solId}`,
        content: btoa(unescape(encodeURIComponent(JSON.stringify(updated, null, 2) + '\n'))),
        branch: BRANCH,
        sha: json.sha,
    }
    const putRes = await fetch(`https://api.github.com/repos/${OWNER}/${REPO}/contents/${PATH}`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${token}`, Accept: 'application/vnd.github+json' },
        body: JSON.stringify(body),
    })
    if (!putRes.ok) {
        const err = await putRes.json().catch(() => ({}))
        throw new Error(err.message || `Error ${putRes.status}`)
    }
}
